export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Cross-bit wallet',
    headline: 'Bitcoin y Crypto Wallet',
    description: 'Envíe, reciba e intercambie Bitcoin y más de 100 criptomonedas con facilidad en las billeteras criptográficas de escritorio , dispositivos móviles y hardware líderes en el mundo.',
    buttonLabel: 'Obtenga Cross-Bit ahora',
    imgStart: '',
    img: 'images/wallet.svg',
    alt: 'Wallet Crypto'
};

export const homeObjTwo = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Sus crypto en cualquier lugar',
    headline: 'Administre criptomonedas en dispositivos móviles',
    description: "Asegure, administre e intercambie sus criptomonedas con la seguridad móvil del escaneo facial o de huellas dactilares.",
    buttonLabel: 'Empiece ahora',
    imgStart: 'start',
    img: 'images/mobile.svg',
    alt: 'Dispositivo móvil'
  };

export const homeObjThree = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: '100% seguro',
    headline: 'Está protegido 24/7 en cualquier lugar en cualquier momento',
    description:
      'Lo tenemos cubierto sin importar dónde se encuentre. Más de 140 ubicaciones en todo el mundo para garantizar que tenga acceso en cualquier momento.',
    buttonLabel: 'Aprenda más',
    imgStart: '',
    img: 'images/security.svg',
    alt: 'Seguridad'
  };
  
  export const homeObjFour = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'ANÁLISIS DE DATOS',
    headline: 'Cada transacción se almacena en nuestra base de datos segura en la nube',
    description:
      'Nunca más tendrá que volver a preocuparse por los recibos guardados. Almacenamos sus datos para que pueda acceder a ellos en cualquier momento.',
    buttonLabel: 'Regístrese ahora',
    imgStart: 'start',
    img: 'images/database.svg',
    alt: 'Base de datos'
  };